<template>
    <CustomHeader :text="$t('activityName.signin_rewards')" />
    <div class="bannerContainer">
        <img :src="dataSet.bannerIcon" alt="">
    </div>
    <div class="checkin_container">
        <van-row class="claimField" v-if="dataSet.hasNotVerifyData">
            <van-col span="18" class="claimText">
                <div class="text"><img src="@/assets/checkinRewards/currency.png" alt="">
                    R$ {{ dataSet.notVerifyConfig?.reward }} × {{ dataSet.notVerifyConfig?.days }}
                    {{ $t('common.days') }}</div>
                <div class="text_2">{{ $t('activity.noPhoneVerification') }}</div>
            </van-col>
            <van-col span="6" class="claimColumn">
                <div class="click_btn" @click="callCheckinClaim(dataSet.notVerifyConfig, 1)"
                    :class="dataSet.isPhoneVerified ? 'disableBtn' : ''">{{
                        $t('activity.claim') }}</div>
            </van-col>
        </van-row>

        <van-row class="claimField" v-if="dataSet.isShowPhoneVerification && dataSet.hasVerifyPhoneData">
            <van-col span="18" class="claimText">
                <div class="text"><img src="@/assets/checkinRewards/currency.png" alt="">
                    R$ {{ dataSet.verifyConfig.reward }} × {{ dataSet.verifyConfig.days }}
                    {{ $t('common.days') }}</div>
                <div class="text_2">{{ $t('activity.phoneVerification') }}
                    <span v-if="dataSet.isPhoneVerified"> {{ $t('activity.verified') }}</span>
                </div>
            </van-col>
            <van-col span="6" class="claimColumn">
                <div v-if="dataSet.isPhoneVerified" class="click_btn"
                    @click="callCheckinClaim(dataSet.verifyConfig, 2)">{{
                        $t('activity.claim') }}</div>
                <div v-if="!dataSet.isPhoneVerified" class="click_btn" @click="goToVerifyPhoneNum(0)">{{
                    $t('activity.verify') }}</div>
            </van-col>
        </van-row>

        <div class="bottom_text" v-if="dataSet.activityInfo.length > 0">
            <div class="title">{{ $t('common.activityTitle') }}</div>
            <div class="line_text" v-for="(item, index) in dataSet.activityInfo" :key="index">
                {{ item }}
            </div>
        </div>
    </div>
    <VerifyPhonePopup ref="verifyPhoneRef" @updateInfo="updateInfo" />
    <CheckinPopup ref="checkinRef" @goToVerify="goToVerifyPhoneNum" />

</template>
<script setup lang="ts">
import CustomHeader from '../components/common/customHeader.vue';
import { defineExpose, ref, defineProps, defineEmits } from 'vue';
import CheckinPopup from './components/checkinPopup.vue';
import VerifyPhonePopup from './components/verifyPhonePopup.vue';
import { CheckingRewardData } from '@/view/checkinRewards/checkinRewards';

const verifyPhoneRef = ref()

const props = defineProps<{
    dataSet: CheckingRewardData
}>()

const emits = defineEmits(['updateInfo', "callCheckinClaim", 'goToVerifyPhoneNum'])
const checkinRef = ref()


const callCheckinClaim = (configData: any, claimType: number) => {
    emits("callCheckinClaim", configData, claimType)
}

const goToVerifyPhoneNum = (type: any) => {
    emits('goToVerifyPhoneNum', type)
}
const updateInfo = () => {
    emits('updateInfo')
}

const openVerifyPhonePopup = () => {
    verifyPhoneRef.value.open()
}

const checkinOpen = (data: any, value: any) => {
    checkinRef.value.open(data, value)
}
const checkinclose = () => {
    checkinRef.value.close()
}
defineExpose({
    checkinOpen,
    checkinclose,
    openVerifyPhonePopup
})
</script>
<style scoped>
.bannerContainer img {
    width: 100%;
}

.bannerContainer {
    padding-top: 50px;
}

.checkin_container {
    padding: 30px 15px;
}

.claimField img {
    width: 15px;
    padding-right: 5px;
}

.claimText {
    color: #fff;
    display: flex;
    justify-content: left;
    flex-direction: column;
    margin-bottom: 20px;
}

.text {
    padding: 2.5px;
    font-size: 12px;
    color: gold;
    font-size: 14px;
}

.text_2 {
    padding: 2.5px;
    font-size: 12px;
    color: #876695;
    font-size: 12px;
}

.text_2 span {
    color: #e61a1a;
    padding: 0 5px;
}

.claimColumn {
    display: flex;
    justify-content: center;
    align-items: center;
}

.click_btn {
    color: #fff;
    font-size: 12px;
    background: linear-gradient(270deg, #e151a4, #e66fc8);
    border-radius: 5px;
    padding: 10px 15px;
    display: flex;
    align-items: center;
    display: flex;
    text-align: center;
    justify-content: center;
    width: 40%;
}

.disableBtn {
    background-image: linear-gradient(rgba(248, 167, 222, 0.234) 0%, rgba(240, 83, 237, 0.24) 100%);
    color: #717171ad;
    font-weight: bold;
}

.bottom_text {
    padding: 25px 0;
}

.line1 {
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    height: 2px;
    margin: 8px 0 0 0;
}

.line2 {
    transform: scaleX(-1);
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    height: 2px;
    margin: 8px 0 0 0;
}

.title {
    color: #7a4289;
    font-weight: bold;
    font-size: 15px;
    padding: 10px 0;
}

.line_text {
    color: #86718c;
    font-size: 13px;
    padding: 5px;
}
</style>